export const CONTINENTS = [
  'Africa',
  'Americas',
  'Asia',
  'Europe',
  'Oceania',
];

export const NOC_CONTINENT = {
  ALG: 'Africa',
  EGY: 'Africa',
  MAR: 'Africa',
  RSA: 'Africa',
  TUN: 'Africa',
  ZIM: 'Africa',

  CHN: 'Asia',
  HKG: 'Asia',
  IND: 'Asia',
  ISR: 'Asia',
  JPN: 'Asia',
  KOR: 'Asia',
  MAS: 'Asia',
  PHI: 'Asia',
  SGP: 'Asia',
  THA: 'Asia',
  TPE: 'Asia',
  UAE: 'Asia',
  VIE: 'Asia',

  AUS: 'Oceania',
  NZL: 'Oceania',

  AUT: 'Europe',
  BEL: 'Europe',
  CZE: 'Europe',
  DEN: 'Europe',
  ESP: 'Europe',
  FIN: 'Europe',
  FRA: 'Europe',
  GBR: 'Europe',
  GER: 'Europe',
  GRE: 'Europe',
  IRL: 'Europe',
  ISL: 'Europe',
  ITA: 'Europe',
  NED: 'Europe',
  NOR: 'Europe',
  POL: 'Europe',
  POR: 'Europe',
  SLO: 'Europe',
  SUI: 'Europe',
  SWE: 'Europe',

  ARG: 'Americas',
  BRA: 'Americas',
  CAN: 'Americas',
  CHI: 'Americas',
  COL: 'Americas',
  CRC: 'Americas',
  ECU: 'Americas',
  MEX: 'Americas',
  PAR: 'Americas',
  PER: 'Americas',
  PUR: 'Americas',
  USA: 'Americas',
  VEN: 'Americas',
};

export const NOC_COUNTRY_NAMES = {
  ALG: 'Algeria',
  AIN: 'Individual Neutral Athlete',
  ARG: 'Argentina',
  AUS: 'Australia',
  AUT: 'Austria',
  BEL: 'Belgium',
  BRA: 'Brazil',
  CAN: 'Canada',
  CHI: 'Chile',
  CHN: 'China',
  COL: 'Colombia',
  CRC: 'Costa Rica',
  CZE: 'Czechia',
  DEN: 'Denmark',
  ECU: 'Ecuador',
  EGY: 'Egypt',
  ESP: 'Spain',
  FIN: 'Finland',
  FRA: 'France',
  GBR: 'Great Britain',
  GER: 'Germany',
  GRE: 'Greece',
  HKG: 'Hong Kong',
  IND: 'India',
  IRL: 'Ireland',
  ISL: 'Iceland',
  ISR: 'Israel',
  ITA: 'Italy',
  JPN: 'Japan',
  KOR: 'South Korea',
  MAR: 'Morocco',
  MAS: 'Malaysia',
  MEX: 'Mexico',
  NED: 'Netherlands',
  NOR: 'Norway',
  NZL: 'New Zealand',
  PAR: 'Paraguay',
  PER: 'Peru',
  PHI: 'Philippines',
  POL: 'Poland',
  POR: 'Portugal',
  PUR: 'Puerto Rico',
  RSA: 'South Africa',
  SGP: 'Singapore',
  SLO: 'Slovenia',
  SUI: 'Switzerland',
  SWE: 'Sweden',
  THA: 'Thailand',
  TPE: 'Chinese Taipei',
  TUN: 'Tunisia',
  UAE: 'United Arab Emirates',
  USA: 'United States of America',
  VEN: 'Venezuela',
  VIE: 'Vietnam',
  ZIM: 'Zimbabwe',
};

export const NOC_MAP_NAMES = {
  ...NOC_COUNTRY_NAMES,
  CZE: 'Czech Republic',
  GBR: 'England',
  KOR: 'Korea',
  RSA: 'South Africa',
  USA: 'United States of America',
};

export const MAP_NAME_TO_NOC = Object.entries(NOC_MAP_NAMES).reduce(
  (acc, [noc, countryName]) => ({
    ...acc,
    [countryName.toLowerCase()]: noc,
  }),
  {
    argentina: 'ARG',
    australia: 'AUS',
    austria: 'AUT',
    belgium: 'BEL',
    canada: 'CAN',
    chile: 'CHI',
    china: 'CHN',
    colombia: 'COL',
    'united states': 'USA',
    'united states of america': 'USA',
    'u.s.a.': 'USA',
    'united kingdom': 'GBR',
    'great britain': 'GBR',
    britain: 'GBR',
    england: 'GBR',
    'czechia': 'CZE',
    'czech republic': 'CZE',
    denmark: 'DEN',
    ecuador: 'ECU',
    spain: 'ESP',
    finland: 'FIN',
    france: 'FRA',
    germany: 'GER',
    india: 'IND',
    ireland: 'IRL',
    israel: 'ISR',
    italy: 'ITA',
    japan: 'JPN',
    'republic of korea': 'KOR',
    'south korea': 'KOR',
    'korea': 'KOR',
    'korea, republic of': 'KOR',
    malaysia: 'MAS',
    mexico: 'MEX',
    morocco: 'MAR',
    netherlands: 'NED',
    norway: 'NOR',
    'new zealand': 'NZL',
    paraguay: 'PAR',
    philippines: 'PHI',
    poland: 'POL',
    'south africa': 'RSA',
    singapore: 'SGP',
    slovenia: 'SLO',
    switzerland: 'SUI',
    sweden: 'SWE',
    thailand: 'THA',
    'united arab emirates': 'UAE',
    uae: 'UAE',
    'chinese taipei': 'TPE',
    taiwan: 'TPE',
    'individual neutral athlete': 'AIN',
    ain: 'AIN',
    'hong kong': 'HKG',
    'hong kong, sar': 'HKG',
    'puerto rico': 'PUR',
    'puerto rico (u.s.)': 'PUR',
  }
);

export const getNocFromMapName = (name) =>
  MAP_NAME_TO_NOC[String(name || '').trim().toLowerCase()] || '';

export const getContinent = (noc) => NOC_CONTINENT[String(noc || '').toUpperCase()] || 'Other';

export const getCountryName = (noc) =>
  NOC_COUNTRY_NAMES[String(noc || '').toUpperCase()] || String(noc || '').toUpperCase();
